import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles'

const TabBar = ({ theme, children }) => (
  <ul className={styles.wrapper}>{React.Children.map(children, child => React.cloneElement(child, { theme }))}</ul>
)

TabBar.propTypes = {
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

TabBar.defaultProps = {
  theme: 'primary',
}

export default TabBar
